<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive>
      <component
        :is="Component"
        v-if="route.meta && route.meta.keepAlive"
        :key="route.name"
      />
    </keep-alive>

    <component
      :is="Component"
      v-if="!route.meta || !route.meta.keepAlive"
      :key="route.fullPath"
    />
  </router-view>
</template>

<script>
import { useVersionCheck } from "./composables/useVersionCheck";

export default {
  name: "App",

  setup() {
    useVersionCheck();
    return {};
  },
};
</script>
